module.exports = __webpack_public_path__ + "img/lessons.1394bd8d.svg";